import { useEffect, useRef, useState } from 'react';
import { Container, Box, Typography } from '@material-ui/core';
import { css } from '@emotion/react';
import { i18n } from 'lib/i18n';
import Button from 'components/shared/Button/Button';
import { unsanitized } from 'styles/utils';
import { sanitize } from 'lib/form';
import { getBrowserName } from 'lib/utils';

const heroDescriptionCss = css`
	margin-top: 5%;
`;

const containerCss = css`
	&.MuiContainer-root {
		display: flex;
		flex-direction: column;
	}
`;

const maxLines = 5;
const expandableTextCss = (showLess: boolean, isSafari: boolean) => css`
	overflow: ${isSafari ? 'none' : showLess ? 'hidden' : 'none'};
	width: 470px;
	max-width: 100%;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${isSafari ? 'auto' : showLess ? maxLines : 'auto'};
`;

interface Props {
	string: string;
}

const ExpandableText = ({ string }: Props) => {
	const [showLess, setShowLess] = useState(true);
	const isSafari = getBrowserName() === 'Safari';

	const toggleHeroDescription = () => {
		setShowLess(prevState => !prevState);
	};

	const expandableTextRef = useRef<HTMLInputElement>(null);
	const [showMoreBtn, setShowMoreBtn] = useState(false);

	useEffect(() => {
		if (expandableTextRef.current) {
			if (expandableTextRef.current.scrollHeight > expandableTextRef.current.offsetHeight) {
				setShowMoreBtn(true);
			}
		}
	}, []);

	return (
		<Container data-aid="ExpandableText" css={containerCss}>
			<div ref={expandableTextRef} css={expandableTextCss(showLess, isSafari)}>
				<Typography
					css={unsanitized}
					dangerouslySetInnerHTML={{
						__html: sanitize(string),
					}}
				/>
			</div>
			<Box css={heroDescriptionCss}>
				{showMoreBtn && (
					<Button variant="outlined" data-aid="button-ExpandableText-read" size="small" onClick={toggleHeroDescription}>
						{i18n.expandableText.read} {showLess ? i18n.expandableText.more : i18n.expandableText.less}
					</Button>
				)}
			</Box>
		</Container>
	);
};

export default ExpandableText;
